import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "Peptide Labs N.I.";
const DEFAULT_IMAGE = "https://images.unsplash.com/photo-1584308972272-9e4e7685e80f?w=1200";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export const Seo = ({ title, description, image = DEFAULT_IMAGE, type = "website", jsonLd, noindex = false }) => {
  const { pathname } = useLocation();
  const ld = jsonLd ? JSON.stringify(jsonLd) : "";

  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE}` : `${SITE} | UK Research Peptides`;
    const url = `${window.location.origin}${pathname}`;
    document.title = fullTitle;
    setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", type);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", image);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", image);
    setCanonical(url);

    document.getElementById("page-jsonld")?.remove();
    if (ld) {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.id = "page-jsonld";
      s.text = ld;
      document.head.appendChild(s);
    }
  }, [title, description, image, type, ld, noindex, pathname]);

  return null;
};
